<template>
    <div class="shadow-md p-3 font-primary">
      <p class="text-xl mb-2 border-b">Mis Datos</p>
      <div v-if="usuario.id" class="w-full flex justify-center">
				<div>
					<p>{{ usuario.email }}</p>
					<p>{{ usuario.razonSocial }}</p>
					<p>{{ usuario.cuit }}</p>
					<form action="">
						<div class="flex justify-center items-center mt-1">
							<p class="w-32">Nombre: </p>
							<input required type="text" v-model="usuario.nombre" class="form-control">
						</div>
						<div class="flex justify-center items-center mt-1">
							<p class="w-32">Apellido: </p>
							<input required type="text" v-model="usuario.apellido" class="form-control">
						</div>
						<div class="flex justify-center items-center mt-1">
							<p class="w-32">Telefono: </p>
							<input required type="text" v-model="usuario.telefono" class="form-control">
						</div>
						<div class="flex justify-center items-center mt-1">
							<p class="w-32">Celular: </p>
							<input required type="text" v-model="usuario.celular" class="form-control">
						</div>
						<div class="flex justify-center items-center mt-1">
							<p class="w-32">Expreso: </p>
							<select required placeholder="Seleccione un expreso" class="form-select" v-model="usuario.idexp">
								<option value="" disabled selected hidden>Seleccione un expreso</option>
								<option v-for="(ex, key) in expresos" :key="key" :value="ex.id">{{ ex.descripcion }}</option>
							</select>
						</div>
						<button class="btn btn-danger bg-truered btn-sm mt-1" type="submit" :disabled="cargando" @click="grabarUsu()">Guardar</button>
					</form>
					<p class="border-t p-1 mt-2">DIRECCIONES</p>
					<!-- <div class="border rounded flex justify-between gap-1">
						<p>{{ usuario.direccion }}, {{ usuario.ciudad }}, {{ this.provincias.find(x => x.id == usuario.provincia).descripcion }}</p>
					</div> -->
					<div v-for="(direccion, key) in direcciones" :key="key" class="border rounded flex justify-between gap-1">
						<p>{{ direccion.DIRECCION }}, {{ direccion.CIUDAD }}, {{ this.provincias.find(x => x.id == direccion.ID_PROVINCIA).descripcion }}</p>
						<button @click="editarDirec(key)" class="w-6" title="Editar"><img src="../assets/icons/pencil.png" alt=""></button>
					</div>
					<div v-for="(direccion, key) in direccionesBodell" :key="key" class="border rounded flex justify-between gap-1">
						<p>{{ direccion.DIRECCION_DIR }}, {{ direccion.LOCALIDAD_DIR }}, {{ this.provincias.find(x => x.id == direccion.IDPRV_DIR).descripcion }}</p>					</div>
					<button @click="nuevaDirec()" class="btn btn-danger bg-truered mt-2 btn-sm">Nueva Direccion</button>
				</div>
			</div>

			<div class="modal fade" id="modalEditDirec" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
						<form action="">
              <div class="modal-body">
								<div class="flex justify-between p-2">
									<p>Direccion: </p>
									<input required placeholder="Dirección de entrega" id="none" autocomplete="off" ref="autocompleteInput" type="text" class="form-control w-2/3" v-model="registro.direccion">
								</div>
								<div class="flex justify-between p-2">
									<p>Provincia: </p>
									<select required placeholder="Seleccione una provincia" class="form-select w-2/3" v-model="registro.provincia">
										<option value="" disabled selected hidden>Seleccione una provincia</option>
										<option v-for="(prov, key) in provincias" :key="key" :value="prov.id">{{ prov.descripcion }}</option>
									</select>
								</div>
								<div class="flex justify-between p-2">
									<p>Ciudad: </p>
									<input required placeholder="Ciudad" id="ciudad" type="text" class="form-control w-2/3" v-model="registro.ciudad">
								</div>
								<div class="flex justify-between p-2">
									<p>Observacion: </p>
									<textarea v-model="registro.obs" class="form-control w-2/3" id="" cols="30" rows="2"></textarea>
								</div>
							</div>
							<div class="modal-footer">
								<button class="btn btn-danger bg-truered" @click="cerrarModal()">Cancelar</button>
								<button class="btn btn-success bg-green-500" type="submit" :disabled="cargando" @click="grabarDirec()">Guardar</button>
							</div>
						</form>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
	import usuarioService from '@/services/usuario.service';
	import authService from '@/services/auth.service';
  export default {
    data() {
      return {
				user: {},
				usuario: {},
				provincias: [
					{ id: 0, descripcion: "CABA" }, // Ciudad Autónoma de Buenos Aires
					{ id: 1, descripcion: "Buenos Aires" },
					{ id: 2, descripcion: "Catamarca" },
					{ id: 3, descripcion: "Córdoba" },
					{ id: 4, descripcion: "Corrientes" },
					{ id: 5, descripcion: "Entre Ríos" },
					{ id: 6, descripcion: "Jujuy" },
					{ id: 7, descripcion: "Mendoza" },
					{ id: 8, descripcion: "La Rioja" },
					{ id: 9, descripcion: "Salta" },
					{ id: 10, descripcion: "San Juan" },
					{ id: 11, descripcion: "San Luis" },
					{ id: 12, descripcion: "Santa Fe" },
					{ id: 13, descripcion: "Santiago del Estero" },
					{ id: 14, descripcion: "Tucumán" },
					{ id: 16, descripcion: "Chaco" },
					{ id: 17, descripcion: "Chubut" },
					{ id: 18, descripcion: "Formosa" },
					{ id: 19, descripcion: "Misiones" },
					{ id: 20, descripcion: "Neuquén" },
					{ id: 21, descripcion: "La Pampa" },
					{ id: 22, descripcion: "Río Negro" },
					{ id: 23, descripcion: "Santa Cruz" },
					{ id: 24, descripcion: "Tierra del Fuego" },
				],
				direcciones: [],
				direccionesBodell: [],
				registro: {},
				cargando: false,
				expresos: []
      };
    },
    mounted() {
			this.$nextTick(() => {
				this.user = JSON.parse(localStorage.getItem('user'))
				this.cargarUsuario()
				this.cargarDirecciones()
				this.cargarDireccionesBodell()
				this.getExpresos()
			})
    },
    methods: {
			getExpresos() {
				authService.expresos()
					.then((res) => {
						this.expresos = res.data.map(x => ({
							id: x.ID_EXP,
							descripcion: x.NOMBRE_EXP
						})).sort((a, b) => {
							const descripcionA = a.descripcion.toLowerCase();
							const descripcionB = b.descripcion.toLowerCase();

							if (descripcionA < descripcionB) {
								return -1;
							}
							if (descripcionA > descripcionB) {
								return 1;
							}
							return 0;
						})
					})
					.catch(err => {
						console.log(err)
					})
			},
			cargarUsuario() {
				usuarioService.getUserId(this.user.id)	
					.then((res) => {
						this.usuario = res.data
					})
					.catch((err) => {
						console.log(err)
					})
			},
			cargarDirecciones() {
				usuarioService.direccionesUsu(this.user.id)
					.then((res) => {
						this.direcciones = res.data
					})
					.catch((err) => {
						console.log(err)
					})
			},
			cargarDireccionesBodell() {
				usuarioService.direccionesUsuBodell(this.user.id)
					.then((res) => {
						this.direccionesBodell = res.data
					})
					.catch((err) => {
						console.log(err)
					})
			},
			nuevaDirec() {
				this.registro = {}
				window.$('#modalEditDirec').modal('show')
			},
			editarDirec(index) {
				this.registro = {
					id: this.direcciones[index].ID,
					direccion: this.direcciones[index].DIRECCION,
					provincia: this.direcciones[index].ID_PROVINCIA,
					ciudad: this.direcciones[index].CIUDAD,
					obs: this.direcciones[index].OBS 
				}
				this.direcciones[index]
				window.$('#modalEditDirec').modal('show')
			},
			cerrarModal() {
				window.$('#modalEditDirec').modal('hide')
			},
			grabarDirec() {
				if (this.registro.direccion &&
				this.registro.provincia &&
				this.registro.ciudad) {
					var direc = this.registro
					direc.idusu = this.user.id
					this.cargando = true
					usuarioService.guardarDireccionesUsu(direc)
						.then(() => {
							this.cargando = false
							this.$root.alertSuccess = true
							this.$root.isAlertVisible = true
							this.cerrarModal()
							this.cargarDirecciones()
						})
						.catch((err) => {
							console.log(err)
							this.$root.alertSuccess = false
							this.$root.isAlertVisible = true
							this.cargando = false
						})
				}
			},
			grabarUsu() {
				if (this.usuario.nombre &&
				this.usuario.apellido &&
				this.usuario.telefono &&
				this.usuario.celular &&
				this.usuario.idexp) {
					this.cargando = true
					usuarioService.updatePerfil(this.usuario)
						.then(() => {
							this.cargando = false
							this.$root.alertSuccess = true
							this.$root.isAlertVisible = true
						})
						.catch((err) => {
							console.log(err)
							this.cargando = false
							this.$root.alertSuccess = false
							this.$root.isAlertVisible = true
						})
				}
			}
    },
    computed: {
    },
  };
  </script>

